const untrailingslashit = (str)=>str.endsWith("/") || str.endsWith("\\") ? untrailingslashit(str.slice(0, -1)) : str;
const trailingslashit = (str)=>`${untrailingslashit(str)}/`;
export { untrailingslashit, trailingslashit };
